<!-- 
    Purpose: To show the mobile view of task list
-->

<template>
  <v-navigation-drawer
    class="elevation-0 theme-border"
    v-model="flag"
    width="100%"
    right
    fixed
    temporary
    hide-overlay
  >
    <v-list-item>
      <v-list-item-content
        class="text-capitalize font-weight-bold dark-purple-text"
      >
        <div v-if="taskToEdit" class="d-flex justify-between">
          <span class="d-inline-block text-capitalize"> Task details </span>
          <v-spacer></v-spacer>
          <v-icon
            @click="(flag = false), (assignedToMenu = false)"
            class="pointer d-flex align-start close-btn"
            small
            >mdi-close</v-icon
          >
        </div>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list v-if="taskToEdit">
      <!-- TASK TITLE -->
      <v-list-item class="py-2">
        <div class="d-flex flex-column align-center w-100">
          <div class="d-flex w-100 body-2 mb-1">
            <div class="dark-purple-text font-weight-bold font-size-15">
              Title
            </div>
            <v-spacer></v-spacer>
            <div
              v-if="getSelectedCompany.role != 'employee'"
              @click="
                selectTask(taskToEdit);
                taskTitle = taskToEdit.title;
                editingTitle = !editingTitle;
              "
              class="pointer light-purple-text underline-hover"
            >
              Edit
            </div>
          </div>
          <div
            class="w-100 dark-purple-text"
            style="
                  word-wrap: break-word !important;
                  word-break: break-word !important;
                  max-width: 100%;
                "
          >
            <v-text-field
              autocomplete="off"
              autofocus
              class=" title-border rounded elevation-0 pl-2 ma-0 body-2"
              v-model="taskTitle"
              dense
              flat
              hide-details=""
              color="#757096"
              placeholder="Add Title"
              v-if="
                selectedTask &&
                  editingTitle &&
                  selectedTask.task_id == taskToEdit.task_id &&
                  (getSelectedCompany.role != 'employee' ||
                    taskToEdit.assigned_by.id == getLoggedInUser.id)
              "
              @click.stop=""
              @keydown.enter="editTaskTitle(taskToEdit)"
              @blur="selectedTask = null"
              @keydown.esc="selectedTask = null"
            >
              <template v-slot:append>
                <v-icon color="green" @click.stop="editTaskTitle(taskToEdit)">
                  mdi-check
                </v-icon>
              </template>
            </v-text-field>
            <span v-else>{{ taskToEdit.title }}</span>
          </div>
        </div>
      </v-list-item>
      <v-divider></v-divider>
      <!-- ASSIGNEE INFO -->
      <v-list-item class="py-2">
        <div class="d-flex flex-column align-center justify-start w-100">
          <div class="d-flex w-100 body-2 mb-2">
            <div class="dark-purple-text font-weight-bold font-size-15">
              Assignee
            </div>
            <v-spacer></v-spacer>
            <div
              @click="openAssignedToMenu()"
              class="pointer light-purple-text underline-hover"
            >
              Edit
            </div>
          </div>
          <div
            class="d-flex align-center px-2 w-100 mb-2 pointer"
            @click="openAssignedToMenu()"
          >
            <!-- Assignee(s) Avatar -->
            <div v-if="newAddedMembersArray.length" class="d-flex">
              <ProfileImage
                v-for="member in newAddedMembersArray.slice(0, 7)"
                :key="member.email"
                v-show="member.image ? ':src' : ':username'"
                :src="member.image"
                :userProfile="true"
                inline
                :username="member.name ? member.name : member.email"
                :size="32"
                :circular="true"
                class="text-light d-inline ml-n2"
              >
              </ProfileImage>
              <ProfileImage
                v-if="newAddedMembersArray.length > 7"
                inline
                :username="`+${newAddedMembersArray.length - 7}`"
                :size="32"
                :userProfile="true"
                :circular="true"
                class="text-light d-inline ml-n3"
              >
              </ProfileImage>
            </div>
            <div  class="d-flex align-center" v-else>
              <span
                class="empty-avatar pointer caption--text d-inline-block d-flex align-center justify-center"
                ><v-icon color="#757096" x-small>mdi-plus</v-icon></span
              >
            </div>
            <!-- Assignee Avatar for Self Assigned -->
            <!-- <span v-else>
              <ProfileImage
                v-show="getLoggedInUser.image ? ':src' : ':username'"
                :src="getLoggedInUser.image"
                :userProfile="true"
                inline
                :username="
                  getLoggedInUser.name
                    ? getLoggedInUser.name
                    : getLoggedInUser.email
                "
                :size="32"
                :circular="true"
                class="text-light d-inline ml-n2"
              >
              </ProfileImage>
            </span> -->
            <span
              v-if="
                taskToEdit.members.length == 1 // ||
                //getSelectedCompany.role == 'employee'
              "
              class="dark-purple-text body-2 text-capitalize mx-1"
              >{{
                getSelectedCompany.role == "employee"
                  ? taskToEdit.members
                    ? taskToEdit.members[0].name
                    : taskToEdit.members[0].email
                  : taskToEdit.members
                  ? taskToEdit.members[0].name
                  : taskToEdit.members[0].email
              }}</span
            >
            <v-spacer></v-spacer>
            <v-progress-circular
              v-if="assigneeLoader"
              indeterminate
              :width="1"
              :size="20"
              color="#2a206a"
            ></v-progress-circular>
          </div>
          <!-- Assigned to Dropdown -->
          <div
            class="w-100"
            v-if="assignedToMenu"
            :class="[{ edited_scrollbar: isMac }]"
          >
            <!-- Search field -->
            <div class="search-border w-100 rounded ma-2">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                solo
                flat
                dense
                autofocus
                v-model="memberSearch"
                autocomplete="off"
              >
              </v-text-field>
            </div>
            <v-list
              v-if="selectedTask"
              class="pointer w-100 overflow-scroll"
              scrollable
              max-height="170"
            >
              <div
                v-for="(member, index) in filteredAllMembers"
                :key="member.email"
                :disabled="
                  (getActiveTask && member.id == getLoggedInUser.id) ||
                  selectedTask.members.length <= 1
                    ? true
                    : false
                "
                class="d-flex listing-hover caption list-item-min-height"
                @click="
                  getActiveTask && getActiveTask.task_id == selectedTask.task_id
                    ? member.id != getLoggedInUser.id
                      ? (newAddedMembers && newAddedMembers.length > 1) ||
                        filteredNonAssignees(selectedTask.task_id).find(
                          (item) => {
                            return item.id == member.id;
                          }
                        )
                        ? addOrRemove(member)
                        : () => {}
                      : () => {}
                    : (newAddedMembers && newAddedMembers.length > 1) ||
                      filteredNonAssignees(selectedTask.task_id).find(
                        (item) => {
                          return item.id == member.id;
                        }
                      )
                    ? addOrRemove(member)
                    : () => {}
                "
                :class="
                  selectedItem == index
                    ? 'bg-hover'
                    : newAddedMembers.find((item) => {
                        return item == member.id;
                      })
                    ? 'bg-selected'
                    : ''
                "
              >
                <profileImage
                  v-show="member.image ? ':src' : ':username'"
                  :src="member.image"
                  inline
                  :username="member.name ? member.name : member.email"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content
                  style="max-width: 160px"
                  class="d-inline-block text-truncate ml-3"
                  v-if="member.name"
                  >{{
                    getLoggedInUser.id == member.id
                      ? "ME"
                      : member.name[0].toUpperCase() +
                        member.name.slice(1).toLowerCase()
                  }}</v-list-item-content
                >
                <v-list-item-content
                  style="max-width: 160px"
                  class="d-inline-block text-truncate ml-3"
                  v-if="!member.name"
                  >{{ member.email }}</v-list-item-content
                >
                <v-spacer></v-spacer>
                <v-icon
                  v-show="
                    newAddedMembers.find((item) => {
                      return item == member.id;
                    })
                  "
                  small
                  class="mr-4"
                  color="#1cc283"
                  >mdi-check-box-outline</v-icon
                >
              </div>
              <div
                v-if="
                  memberSearch &&
                    !filteredAssignees(selectedTask.task_id).length &&
                    !filteredNonAssignees(selectedTask.task_id).length
                "
              >
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
            <v-btn
              @click="dialog = true"
              color="#EEF0F6"
              block
              tile
              depressed
              class="listing-hover text-capitalize dark-purple-text"
            >
              <v-icon size="16" class="mx-1">mdi-plus</v-icon>
              <span>Add New Member</span></v-btn
            >
          </div>
        </div>
      </v-list-item>
      <v-divider></v-divider>
      <!-- PROJECT INFO -->
      <v-list-item class="py-2">
        <div class="d-flex flex-column align-center justify-start w-100">
          <div class="d-flex w-100 body-2 mb-1">
            <div class="dark-purple-text font-weight-bold font-size-15">
              Project
            </div>
            <v-spacer></v-spacer>
            <div
              v-if="
                taskToEdit.assigned_by &&
                  (taskToEdit.assigned_by.id == getLoggedInUser.id ||
                    getSelectedCompany.role != 'employee')
              "
              @click="
                (projectMenu = !projectMenu),
                  (projectBtn = true),
                  (editIcon = false),
                  projectMenu ? (projectSearch = null) : () => {}
              "
              class="pointer light-purple-text underline-hover"
            >
              Edit
            </div>
          </div>
          <div
            class="d-flex align-center dark-purple-text w-100 mx-4"
            :class="
              taskToEdit.assigned_by.id == getLoggedInUser.id ||
              getSelectedCompany.role != 'employee'
                ? 'pointer'
                : ''
            "
            @click="
              if (
                taskToEdit.assigned_by.id == getLoggedInUser.id ||
                getSelectedCompany.role != 'employee'
              ) {
                (editIcon = false),
                  (projectMenu = !projectMenu),
                  (projectBtn = true),
                  projectMenu ? (projectSearch = null) : () => {};
              }
            "
          >
            <!-- Project Name -->
            <v-btn
              class="task-bar-btns-borders task-bar-btn-dimensions mt-1"
              depressed
              v-if="taskToEdit.project"
            >
              <v-icon class="ml-1" :size="9"> mdi-circle </v-icon>
              <span
                style="max-width: 130px"
                class="text-capitalize body-2 d-inline-block text-truncate px-1"
              >
                {{
                  taskToEdit.project.name ? taskToEdit.project.name : "Project"
                }}
              </span>
            </v-btn>
            <span v-else class="grey--text subtitle-2 font-italic">
              No Project
            </span>

            <v-spacer></v-spacer>

            <v-progress-circular
              v-if="projectLoader"
              indeterminate
              :width="1"
              :size="20"
              color="#2a206a"
            ></v-progress-circular>
          </div>

          <!-- Project Dropdown  -->
          <div
            v-if="projectMenu"
            :class="[{ edited_scrollbar: isMac }]"
            class="theme-border rounded mt-2 dropdown-width"
          >
            <div>
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search"
                color="#2a206a"
                class="pa-1"
                hide-details
                solo
                dense
                flat
                autofocus
                outlined
                autocomplete="off"
                v-model="projectSearch"
                @keydown.enter="
                  selectedItem != null
                    ? updateSelectedProject(
                        projectsList[selectedItem],
                        taskToEdit
                      )
                    : selectedItem != null && projectSearch
                    ? updateSelectedProject(projectsList[0], taskToEdit)
                    : projectSearch && projectsList.length == 0
                    ? createProject()
                    : ''
                "
                @keydown.up="selectPrev"
                @keydown.down="selectNext"
              >
              </v-text-field>
              <v-list max-height="160" class="pointer overflow-scroll">
                <small
                  class="caption d-flex justify-center align-center"
                  v-if="!projectSearch && !getProjects.length"
                >
                  Please enter the project name
                </small>
                <div
                  v-for="(project, index) in projectsList"
                  :key="project.id"
                  class="listing-hover d-flex pointer list-item-min-height"
                  :class="
                    selectedItem == index
                      ? 'bg-hover'
                      : taskToEdit.project
                      ? taskToEdit.project.id == project.id
                        ? 'bg-selected'
                        : projectSearch && index == 0
                        ? 'bg-search-result'
                        : ''
                      : ''
                  "
                >
                  <v-text-field
                    v-if="project.edit"
                    v-model="editProjectName"
                    dense
                    outlined
                    hide-details
                    color="#2a206a"
                    flat
                    class="w-100 pl-2 caption"
                    autofocus
                    autocomplete="off"
                    @blur="
                      project.edit = false;
                      project.id != editIcon;
                    "
                  >
                  </v-text-field>
                  <div
                    v-if="!project.edit"
                    @click="
                      taskToEdit.project
                        ? taskToEdit.project.id == project.id
                          ? updateSelectedProject(null, taskToEdit)
                          : updateSelectedProject(project, taskToEdit)
                        : updateSelectedProject(project, taskToEdit)
                    "
                    class="d-flex align-center w-100"
                  >
                    <div class="d-flex list-item-min-height">
                      <profileImage
                        inline
                        :username="project.name"
                        :size="23"
                        :circular="true"
                        class="ml-3 text-light"
                      >
                      </profileImage>
                      <v-list-item-content
                        ><span
                          style="max-width: 160px"
                          class="
                            ml-2
                            d-inline-block
                            text-truncate
                            w-12
                            caption
                            text-capitalize
                          "
                        >
                          {{ project.name ? project.name : "No Project" }}
                        </span>
                      </v-list-item-content>
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-icon
                    small
                    color="#1cc283"
                    class="mr-3"
                    v-text="
                      taskToEdit.project
                        ? taskToEdit.project.id == project.id
                          ? 'mdi-check-box-outline'
                          : ''
                        : ''
                    "
                  ></v-icon>
                  <!-- Update project -->
                  <v-icon
                    v-show="project.id == editIcon"
                    class="mr-1 dark-purple-text"
                    :class="
                      getSelectedCompany.role == 'team-manager' ||
                      getSelectedCompany.role == 'employee'
                        ? 'd-none'
                        : ''
                    "
                    @click="updateProject(project)"
                    small
                  >
                    mdi-check
                  </v-icon>
                  <!-- Edit project -->
                  <v-icon
                    v-show="project.id != editIcon"
                    class="mr-1 dark-purple-text"
                    :class="
                      getSelectedCompany.role == 'team-manager' ||
                      getSelectedCompany.role == 'employee'
                        ? 'd-none'
                        : ''
                    "
                    @click="editProject(project)"
                    small
                  >
                    mdi-pencil
                  </v-icon>
                  <!-- Delete project -->
                  <v-icon
                    class="dark-purple-text mr-2"
                    @click="deleteProject(project)"
                    small
                    :class="
                      getSelectedCompany.role == 'team-manager' ||
                      getSelectedCompany.role == 'employee'
                        ? 'd-none'
                        : ''
                    "
                    >mdi-trash-can-outline</v-icon
                  >
                </div>
                <div v-if="projectSearch && !projectsList.length">
                  <p class="no-results-found my-1">No results found</p>
                </div>
              </v-list>
              <v-btn
                v-if="projectBtn"
                @click="projectSearch ? createProject() : (projectBtn = false)"
                color="#EEF0F6"
                block
                depressed
                tile
                height="40px"
                class="listing-hover my-t text-capitalize"
                :class="
                  !projectBtn ||
                  getSelectedCompany.role == 'team-manager' ||
                  getSelectedCompany.role == 'employee'
                    ? 'd-none'
                    : ''
                "
              >
                <v-icon class="mx-1">mdi-plus</v-icon>
                <span
                  style="max-width: 160px"
                  class="d-inline-block text-truncate"
                >
                  Add
                  {{
                    projectsList && !projectsList.length
                      ? projectSearch
                      : "New Project"
                  }}
                </span></v-btn
              >
              <v-text-field
                class="pa-0 ma-0 caption"
                v-if="!projectBtn"
                prepend-inner-icon="mdi-plus"
                color="#2a206a"
                background-color="#F8F7FD"
                hide-details
                autofocus
                v-model="searchProject"
                autocomplete="off"
                solo
                dense
                flat
                @keydown.enter="createProject(), (projectBtn = true)"
              >
                <template v-slot:append>
                  <div class="font-size-10 pa-0 ma-0" color="#2a206a">
                    *press enter to add
                  </div>
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <br />
      </v-list-item>
      <v-divider></v-divider>
      <!-- DUE DATE -->
      <v-list-item class="py-2">
        <div class="d-flex flex-column align-center justify-start w-100">
          <div class="d-flex w-100 body-2 mb-1">
            <div class="dark-purple-text font-weight-bold font-size-15">
              Due Date
            </div>
            <v-spacer></v-spacer>
            <div
              v-if="
                taskToEdit.assigned_by &&
                  (taskToEdit.assigned_by.id == getLoggedInUser.id ||
                    getSelectedCompany.role != 'employee')
              "
              @click="openCalendarMenu"
              class="pointer light-purple-text underline-hover"
            >
              Edit
            </div>
          </div>
          <!-- no due date Dropdown -->
          <div
            class="d-flex align-center mt-2 w-100"
            @click="
              if (
                taskToEdit.assigned_by.id == getLoggedInUser.id ||
                getSelectedCompany.role != 'employee'
              ) {
                openCalendarMenu();
              }
            "
            :class="
              taskToEdit.assigned_by.id == getLoggedInUser.id ||
              getSelectedCompany.role != 'employee'
                ? 'pointer'
                : ''
            "
          >
            <img src="@/assets/images/calendar_lightpurple.svg" height="16px" />
            <div v-show="taskToEdit.due_date">
              <div class="text-caption">
                <v-chip
                  class="
                    due_date-chip-task
                    text-caption
                    ml-1
                    d-flex
                    justify-center
                  "
                  label
                  small
                  dark
                  :class="
                    taskToEdit.assigned_by &&
                    taskToEdit.assigned_by.id != getLoggedInUser.id &&
                    getSelectedCompany.role == 'employee'
                      ? ''
                      : 'pointer'
                  "
                  :color="
                    taskToEdit.due_date === getCurrentDate()
                      ? 'yellow-chip-color'
                      : taskToEdit.due_date < getCurrentDate()
                      ? 'red-chip-color'
                      : 'green-chip-color'
                  "
                >
                  <span v-if="taskToEdit.due_date === getCurrentDate()">
                    Today
                  </span>
                  <span
                    v-else-if="
                      taskToEdit.due_date ===
                        getTommorrowDate(taskToEdit.due_date)
                    "
                  >
                    Tomorrow
                  </span>
                  <span v-else>
                    {{ getDueDate(taskToEdit.due_date) }}
                  </span>
                </v-chip>
              </div>
            </div>
            <span
              class="mx-1 grey--text font-italic caption"
              v-show="!taskToEdit.due_date"
              >No Due Date</span
            >
          </div>
          <!-- Remove Due Date -->
          <div
            v-if="
              taskToEdit.due_date &&
                (taskToEdit.assigned_by.id == getLoggedInUser.id ||
                  getSelectedCompany.role != 'employee')
            "
            class="d-flex align-center mt-2 my-1 w-100"
          >
            <span
              @click="
                updateDueDate(null, taskToEdit),
                  (dateMenu = false),
                  (taskToEdit.due_date = null)
              "
              class="text-capitalize pointer underline caption mx-1"
              text
              color="#2a206a"
              outlined
            >
              Remove due date
            </span>
          </div>
          <!-- Date Picker -->
          <div v-if="showCalendar" class="theme-border rounded mt-2 pb-2">
            <v-date-picker
              id="kanban-sidebar-due-date"
              v-if="
                taskToEditDate == taskToEdit.task_id &&
                  taskToEdit.assigned_by &&
                  (getSelectedCompany.role != 'employee' ||
                    taskToEdit.assigned_by.id == getLoggedInUser.id)
              "
              v-model="date"
              color="#2a206a"
              @input="
                updateDueDate(date, taskToEdit),
                  (dateMenu = false),
                  (showCalendar = false)
              "
            >
            </v-date-picker>
          </div>
        </div>
      </v-list-item>
      <v-divider></v-divider>

      <!-- Priority -->
      <v-list-item class="py-2">
        <div
          @click="priorityMenu = !priorityMenu"
          class="d-flex w-100 flex-column"
        >
          <div class="d-flex w-100 align-center">
            <div class="dark-purple-text body-2 font-weight-bold font-size-15">
              Priority
            </div>
            <v-spacer></v-spacer>
            <div
              v-if="
                taskToEdit.assigned_by &&
                  (taskToEdit.assigned_by.id == getLoggedInUser.id ||
                    getSelectedCompany.role != 'employee')
              "
              @click="priorityMenu == true"
              class="pointer light-purple-text body-2 underline-hover"
            >
              Edit
            </div>
          </div>
          <div v-if="priorityMenu">
            <div
              v-for="(priority, i) in ['low', 'medium', 'high']"
              :key="i"
              :class="
                taskToEdit.priority && taskToEdit.priority == priority
                  ? 'bg-selected'
                  : ''
              "
              class="
                body-2
                listing-hover
                dark-purple-text
                pointer
                text-capitalize
                px-2
                py-1
              "
              @click="setPriority(taskToEdit, priority)"
            >
              <span>{{ priority }}</span>
            </div>
          </div>
          <v-chip
            class="due_date-chip my-1 text-capitalize text-caption"
            label
            small
            dark
            :class="
              taskToEdit.assigned_by.id != getLoggedInUser.id &&
              getSelectedCompany.role == 'employee'
                ? ''
                : 'pointer'
            "
            :color="
              taskToEdit.priority == 'high'
                ? 'red-chip-color d-flex justify-center'
                : taskToEdit.priority == 'medium'
                ? 'orange-chip-color d-flex justify-center'
                : taskToEdit.priority == 'low'
                ? 'yellow-chip-color d-flex justify-center'
                : taskToEdit.assigned_by.id != getLoggedInUser.id &&
                  getSelectedCompany.role == 'employee'
                ? 'transparent-chip-color w-100 caption px-0 font-italic grey--text'
                : 'transparent-chip-color d-flex justify-center body-2 px-0 font-italic'
            "
          >
            {{
              taskToEdit.priority
                ? taskToEdit.priority
                : taskToEdit.assigned_by.id != getLoggedInUser.id &&
                  getSelectedCompany.role == "employee"
                ? "Priority not set"
                : "Set priority"
            }}
          </v-chip>
        </div>
      </v-list-item>
      <v-divider></v-divider>

      <!-- Recurring -->
      <v-list-item class="py-2">
        <div @click="repeatMenu = !repeatMenu" class="d-flex w-100 flex-column">
          <div class="d-flex w-100 align-center">
            <div class="dark-purple-text body-2 font-weight-bold font-size-15">
              Repeat
            </div>
            <v-spacer></v-spacer>
            <div
              v-if="
                taskToEdit.assigned_by &&
                  (taskToEdit.assigned_by.id == getLoggedInUser.id ||
                    getSelectedCompany.role != 'employee')
              "
              @click="repeatMenu == true"
              class="pointer light-purple-text body-2 underline-hover"
            >
              Edit
            </div>
          </div>
          <div v-if="repeatMenu">
            <div
              v-for="(recurring_type, i) in ['daily', 'weekly', 'monthly']"
              :key="i"
              :class="
                taskToEdit.recurring_type &&
                taskToEdit.recurring_type == recurring_type
                  ? 'bg-selected'
                  : ''
              "
              class="
                body-2
                listing-hover
                dark-purple-text
                pointer
                text-capitalize
                px-2
                py-1
              "
              @click="
                repeatTask(
                  taskToEdit,
                  recurring_type == taskToEdit.recurring_type
                    ? null
                    : recurring_type
                )
              "
            >
              <span>{{ recurring_type }}</span>
            </div>
          </div>
          <v-chip
            class="due_date-chip my-1 text-capitalize"
            label
            small
            dark
            :class="
              taskToEdit.assigned_by.id != getLoggedInUser.id &&
              getSelectedCompany.role == 'employee'
                ? ''
                : 'pointer'
            "
            :color="
              taskToEdit.recurring_type == 'daily'
                ? 'red-chip-color d-flex justify-center'
                : taskToEdit.recurring_type == 'weekly'
                ? 'orange-chip-color d-flex justify-center'
                : taskToEdit.recurring_type == 'monthly'
                ? 'yellow-chip-color d-flex justify-center'
                : taskToEdit.assigned_by.id != getLoggedInUser.id &&
                  getSelectedCompany.role == 'employee'
                ? 'transparent-chip-color w-100 caption px-0 font-italic grey--text'
                : 'transparent-chip-color d-flex justify-center body-2 px-0 font-italic'
            "
          >
            {{
              taskToEdit.recurring_type
                ? taskToEdit.recurring_type
                : "Doesn't repeat"
            }}
          </v-chip>
        </div>
      </v-list-item>
      <v-divider></v-divider>
      <!-- Status -->
      <v-list-item class="py-2">
        <div class="d-flex flex-column align-center justify-start w-100">
          <div class="d-flex w-100 body-2 mb-1">
            <div class="dark-purple-text font-weight-bold font-size-15">
              Status
            </div>
          </div>
          <div class="d-flex justify-start w-100">
            <v-chip
              class="
                d-flex
                justify-center
                my-1
                text-capitalize text-caption
                status-chip-kanban
              "
              label
              small
              :class="
                taskToEdit.overdue && taskToEdit.status != 'completed'
                  ? 'red-chip-color'
                  : (taskToEdit.status === 'active' && taskToEdit.running) ||
                    (getActiveTask &&
                      taskToEdit.task_id == getActiveTask.task_id)
                  ? 'blue-chip-color'
                  : taskToEdit.status === 'active' && !taskToEdit.running
                  ? 'light-blue-chip-color'
                  : taskToEdit.status === 'pending'
                  ? 'yellow-chip-color'
                  : taskToEdit.status === 'completed'
                  ? 'green-chip-color'
                  : ''
              "
            >
              {{
                taskToEdit.overdue && taskToEdit.status != "completed"
                  ? "Overdue"
                  : taskToEdit.status === "pending"
                  ? "Pending"
                  : taskToEdit.status === "completed"
                  ? "Completed"
                  : (taskToEdit.status === "active" && taskToEdit.running) ||
                    (getActiveTask &&
                      taskToEdit.task_id == getActiveTask.task_id)
                  ? "Active"
                  : taskToEdit.status === "active" && !taskToEdit.running
                  ? "Paused"
                  : ""
              }}
            </v-chip>
          </div>
        </div>
      </v-list-item>
      <v-divider></v-divider>
      <!--My Durations -->
      <v-list-item class="py-2">
        <div
          class="
            d-flex
            flex-column
            align-center
            justify-start
            dark-purple-text
            w-100
          "
        >
          <div
            class="d-flex flex-column w-100 body-2"
            :class="isMac ? 'edited_scrollbar' : ''"
          >
            <div class="d-flex w-100 body-2 mb-1">
              <div class="dark-purple-text font-weight-bold font-size-15">
                <v-btn
                  v-if="taskToEdit.interval.length"
                  class="expanding-chevron-bg px-0"
                  icon
                  x-small
                  @click="isExpanded = !isExpanded"
                >
                  <v-icon color="#1CC283">
                    {{ !isExpanded ? "mdi-chevron-right" : "mdi-chevron-down" }}
                  </v-icon>
                </v-btn>
                Durations
              </div>
              <v-spacer></v-spacer>
              <div class="font-weight-bold">
                {{ getTotalDuration(taskToEdit) }}
              </div>
            </div>
            <span v-if="isExpanded" class="y-scroll" style="max-height: 100px">
              <div
                class="d-flex mb-1"
                v-for="interval in taskToEdit.interval"
                :key="interval.id"
              >
                <v-menu
                  :close-on-content-click="false"
                  ref="editMenu"
                  tile
                  bottom
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="dark-purple-text font-size-14 ml-7"
                      v-on="on"
                      v-show="
                        !getActiveTimeEntry ||
                          (getActiveTimeEntry &&
                            interval.entry_id != getActiveTimeEntry.entry_id)
                      "
                      v-bind="attrs"
                      @click="
                        selectedInterval = Object.assign({}, interval);
                        timeEntryMenu = true;
                      "
                    >
                      <span class="pointer interval-time">
                        {{
                          interval
                            ? interval.start_time
                              ? interval.start_time.slice(11, 16)
                              : ""
                            : ""
                        }}
                      </span>

                      -
                      <span class="pointer interval-time">
                        {{
                          interval
                            ? interval.end_time
                              ? interval.end_time.slice(11, 16)
                              : ""
                            : ""
                        }}
                      </span>
                    </div>
                    <div
                      v-show="
                        getActiveTimeEntry &&
                          interval.entry_id == getActiveTimeEntry.entry_id
                      "
                    >
                      <span
                        class="pointer underline ml-7"
                        v-text="
                          interval
                            ? interval.start_time
                              ? interval.start_time.slice(11, 16)
                              : ''
                            : ''
                        "
                      ></span>
                    </div>
                  </template>
                  <v-card
                    :width="
                      $vuetify.breakpoint.xl || $vuetify.breakpoint.lg
                        ? '300px'
                        : '380px'
                    "
                    outlined
                    tile
                    v-if="timeEntryMenu"
                  >
                    <v-card-text class="black--text">
                      <div class="d-flex align-center">
                        <!-- Icons -->
                        <div class="d-flex flex-column mx-1">
                          <v-icon
                            light
                            color="black"
                            :class="$vuetify.breakpoint.xs ? 'mt-1' : 'my-2'"
                            >mdi-calendar-outline</v-icon
                          >

                          <v-icon color="black">mdi-clock-outline</v-icon>
                        </div>
                        <!-- Chips -->
                        <div>
                          <!-- Date Chips -->
                          <div class="d-flex align-center my-1">
                            <!-- start date -->
                            <input
                              type="date"
                              style="border-radius: 5px"
                              ref="startDate"
                              v-model="entryDate"
                              class="
                                d-block
                                due_date-chip-xs
                                font-weight-light
                                light-purple-bg
                                pointer
                              "
                              :class="
                                $vuetify.breakpoint.xs
                                  ? 'time-style-sm'
                                  : 'time-style'
                              "
                            />

                            <div class="mx-1">-</div>
                            <!-- end date -->
                            <input
                              type="date"
                              style="border-radius: 5px"
                              ref="endDate"
                              v-model="entryDate"
                              class="
                                d-block
                                due_date-chip-xs
                                font-weight-light
                                light-purple-bg
                                pointer
                              "
                              :class="
                                $vuetify.breakpoint.xs
                                  ? 'time-style-sm'
                                  : 'time-style'
                              "
                            />
                          </div>
                          <!-- Time Chips -->
                          <div class="d-flex align-center">
                            <!-- Start Time -->
                            <input
                              type="time"
                              style="border-radius: 5px"
                              ref="startTime"
                              v-model="startTime"
                              class="
                                d-block
                                due_date-chip-xs
                                font-weight-light
                                light-purple-bg
                                pointer
                              "
                              :class="
                                $vuetify.breakpoint.xs
                                  ? 'time-style-sm'
                                  : 'time-style'
                              "
                            />
                            <div class="mx-1">-</div>
                            <!-- Stop Time -->
                            <input
                              type="time"
                              style="border-radius: 5px"
                              ref="endTime"
                              v-model="endTime"
                              :class="
                                $vuetify.breakpoint.xs
                                  ? 'time-style-sm'
                                  : 'time-style'
                              "
                              class="
                                d-block
                                due_date-chip-xs
                                light-purple-bg
                                font-weight-light
                                pointer
                              "
                            />
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mt-2 align-center">
                        <v-spacer></v-spacer>

                        <v-btn
                          depressed
                          @click="editTimeEntry(interval)"
                          small
                          class="btn-success white--text"
                          >Save
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu>
                <v-spacer></v-spacer>
                <div>
                  <span>
                    {{
                      interval
                        ? interval.duration
                          ? format(interval.duration)
                          : "00:00:00"
                        : ""
                    }}
                  </span>

                  <v-btn
                    icon
                    x-small
                    class="cross-icon-style"
                    @click="deleteTimeEntry(interval)"
                  >
                    <v-icon color="red" x-small> mdi-close </v-icon>
                  </v-btn>
                </div>
              </div>
            </span>
          </div>
        </div>
      </v-list-item>
      <v-divider></v-divider>
      <!-- TIME SPENT -->
      <v-list-item class="py-2">
        <div
          class="
            d-flex
            flex-column
            align-center
            justify-start
            dark-purple-text
            w-100
          "
        >
          <div
            class="d-flex flex-column w-100 body-2 mb-1"
            :class="isMac ? 'edited_scrollbar' : ''"
          >
            <div class="dark-purple-text font-weight-bold font-size-15">
              Time Spent
            </div>

            <span
              v-if="getSelectedCompany.role != 'employee'"
              class="y-scroll"
              style="max-height: 190px"
            >
              <div
                class="d-flex align-center justify-start"
                v-for="member in taskToEdit.members"
                :key="member.id"
              >
                <profileImage
                  inline
                  v-show="member.image ? ':src' : ':username'"
                  :src="member.image"
                  :username="member.name ? member.name : member.email"
                  :size="30"
                  :userProfile="true"
                  :circular="true"
                  class="my-2 text-light d-inline mx-2"
                >
                </profileImage>
                <span
                  class="d-inline-block text-capitalize text-truncate mr-1"
                  >{{ member.name ? member.name : member.email }}</span
                >
                <v-spacer></v-spacer>
                <span class="d-inline-block">
                  {{
                    member
                      ? member.id == getLoggedInUser.id
                        ? getTotalDuration(taskToEdit)
                        : format(member.duration)
                      : ""
                  }}
                </span>
              </div>
            </span>
            <span v-else>
              <div class="d-flex align-center justify-start">
                <profileImage
                  inline
                  v-show="getLoggedInUser.image ? ':src' : ':username'"
                  :src="getLoggedInUser.image"
                  :username="
                    getLoggedInUser.name
                      ? getLoggedInUser.name
                      : getLoggedInUser.email
                  "
                  :size="30"
                  :userProfile="true"
                  :circular="true"
                  class="my-2 text-light d-inline mx-2"
                >
                </profileImage>
                <span
                  class="d-inline-block text-capitalize text-truncate mr-1"
                  >{{
                    getLoggedInUser.name
                      ? getLoggedInUser.name
                      : getLoggedInUser.email
                  }}</span
                >
                <v-spacer></v-spacer>
                <span class="d-inline-block">
                  {{ getTotalDuration(taskToEdit) }}
                </span>
              </div>
            </span>
          </div>
        </div>
      </v-list-item>
      <v-divider></v-divider>
      <!-- Delete task-->
      <v-list-item
        class="py-2 d-flex justify-center"
        v-if="
          taskToEdit.assigned_by &&
            (taskToEdit.assigned_by.id == getLoggedInUser.id ||
              getSelectedCompany.role != 'employee')
        "
        @click="(flag = false), deleteTaskEntry(taskToEdit)"
      >
        <div
          class="
            d-flex
            align-center
            delete-task-text
            font-size-15 font-weight-bold
            justify-center
            delete-task-block
          "
        >
          Delete this task
        </div>
      </v-list-item>
      <!-- snackbar -->
      <SnackbarNew
        :snackbar.sync="snackbar"
        :snackbarError="snackbarError"
        :snackbarMessage="snackbarMessage"
      />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import timer from "@/timer";
import moment from "moment";
import { eventBus } from "@/main";
import { dateHelpersMixin } from "@/mixins/dateHelpersMixin";
import { tasksMixin } from "@/mixins/tasksMixin";
import { memberSearchMixin } from "@/mixins/memberSearchMixin";
import { addOrRemoveMember } from "@/mixins/addOrRemoveMember";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { projectsCRUD } from "@/mixins/projectsCRUD";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  name: "MobileTaskList",
  props: ["taskToEdit", "drawer", "assignMenu"],
  data() {
    return {
      priorityMenu: false,
      repeatMenu: false,
      flag: null,
      taskToEditDate: null,
      assignedToMenu: false,
      selectedItem: null,
      selectedMember: null,
      memberSearch: null,
      projectMenu: false,
      showCalendar: false,
      editProjectName: null,
      searchProject: null,
      projectSearch: null,
      projectBtn: true,
      date: new Date().toISOString().substr(0, 10),
      projectLoader: false,
      assigneeLoader: false,
      tempMembers: [], // Temporary members being added from add member component
      openAddMemberModal: false,
      isExpanded: false,
      timeEntryMenu: false,
      selectedInterval: {},
      entryDate: moment().format("YYYY-MM-DD"),
      endTime: null, // Edited time entry
      startTime: null, // Edited time entry
    };
  },
  components: {
    ProfileImage: () => import("@/components/Includes/ProfileImage"),
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  mixins: [
    dateHelpersMixin,
    tasksMixin,
    memberSearchMixin,
    addOrRemoveMember,
    snackbarMixin,
    projectsCRUD,
  ],
  watch: {
    taskToEdit(value) {
      this.selectedTask = value;
    },
    getAllMembers(value, oldValue) {
      if (value > oldValue) {
        this.tempMembers = [];
      }
    },
    drawer(value) {
      value ? (this.flag = true) : (this.flag = false);
    },
    flag(value) {
      if (value) {
        this.newAddedMembersArray = [...this.taskToEdit.members];
        this.removedMembersArray = [];
      }
      if (!value) {
        this.newAddedMembersArray = [];
        this.$emit("update:drawer", false);
      }
    },
    // Time entry being edited
    selectedInterval(value) {
      if (value) {
        this.entryDate = value.start_time.slice(0, 10);
        this.startTime = value.start_time.slice(11, 16);
        this.endTime = value.end_time.slice(11, 16);
      }
    },
  },
  computed: {
    ...mapGetters([
      "getLoggedInUser",
      "getSelectedCompany",
      "getAssignees",
      "getNonAssignees",
      "getActiveTimeEntry",
      "getActiveTask",
      "getProjects",
      "getTimeEntry",
      "getTask",
      "getActiveTasks",
      "getProject",
    ]),
    projectsList() {
      return this.projectSearch && this.getProjects
        ? this.getProjects.filter((item) => {
            return item.name
              ? item.name
                  .toLowerCase()
                  .includes(this.projectSearch.toLowerCase())
              : false;
          })
        : this.getProjects;
    },
  },
  mounted() {
    eventBus.$on("openSideBar", () => {
      this.assignedToMenu = false;
      this.projectMenu = false;
      this.priorityMenu = false;
      this.repeatMenu = false;
      this.editIcon = false;
      this.isExpanded = false;
    });
  },
  methods: {
    repeatTask(task, recurring_type) {
      let oldData = {
        is_recurring: task.recurring_type ? true : false,
        recurring_type: task.recurring_type,
      };
      let data = {
        company_id: this.getSelectedCompany.id,
        task_id: task.task_id,
        is_recurring: recurring_type ? true : false,
        recurring_type: recurring_type,
      };
      this.$store.dispatch("updateTask", data).catch(() => {
        oldData.task = this.getTask(task.task_id);
        this.$store.commit("setUpdatedCard", oldData);

        // ERROR Snackbar
      });

      // Temporary update
      data.task = this.getTask(task.task_id);
      this.$store.commit("setUpdatedCard", data);
    },

    openAssignedToMenu() {
      this.assignedToMenu = !this.assignedToMenu;
    },
    // Formats time to HH:mm:ss
    format(value) {
      return timer.format(value);
    },
    openCalendarMenu() {
      this.showCalendar = !this.showCalendar;
      this.taskToEditDate = this.taskToEdit.task_id;
      this.taskToEdit.due_date
        ? (this.date = this.taskToEdit.due_date)
        : (this.date = new Date().toISOString().substr(0, 10));
    },

    filteredAssignees(task_id) {
      return this.getAssignees(task_id)
        ? this.memberSearch
          ? this.getAssignees(task_id).filter((item) => {
              return item.name
                ? item.name
                    .toLowerCase()
                    .includes(this.memberSearch.toLowerCase())
                : item.email
                    .toLowerCase()
                    .includes(this.memberSearch.toLowerCase());
            })
          : this.getAssignees(task_id)
        : [];
    },

    filteredNonAssignees(task_id) {
      return this.getNonAssignees(task_id)
        ? this.memberSearch
          ? this.getNonAssignees(task_id).filter((item) => {
              return item.name
                ? item.name
                    .toLowerCase()
                    .includes(this.memberSearch.toLowerCase())
                : item.email
                    .toLowerCase()
                    .includes(this.memberSearch.toLowerCase());
            })
          : this.getNonAssignees(task_id)
        : [];
    },
    // check if logged in user is a member of a task
    isMember(task) {
      return task.members.find((item) => {
        return item.id == this.getLoggedInUser.id;
      });
    },
    // Duration from creation of task till last stop
    getTotalDuration(task) {
      let totalDuration = 0;
      if (!this.isMember(task)) {
        for (let member of task.members) {
          if (member.duration)
            totalDuration = totalDuration + parseInt(member.duration);
        }
      } else {
        for (let interval of task.interval) {
          if (interval.duration)
            totalDuration = totalDuration + parseInt(interval.duration);
        }
      }
      return timer.format(totalDuration);
    },
    updateDueDateCard(date, taskData) {
      let body = {
        company_id: this.getSelectedCompany.id,
        task_id: taskData.task_id,
        due_date: date,
      };
      let oldDate = taskData.due_date;
      let oldStatus = taskData.status;
      taskData.due_date = date;
      if (
        date < moment().format("YYYY-MM-DD") &&
        taskData.status != "completed"
      ) {
        taskData.status = "overdue";
        taskData.overdue = true;
      } else {
        if (taskData.status == "overdue") {
          if (taskData.interval.length) {
            taskData.status = "active";
          } else if (!taskData.interval.length) {
            taskData.status = "pending";
          }
        }
        taskData.overdue = false;
      }
      this.$store
        .dispatch("editTaskCardInfo", body)
        .then((res) => {
          this.openSnackbar(false, res.data.error_msg);
        })
        .catch((error) => {
          taskData.due_date = oldDate;
          taskData.status = oldStatus;
          if (error.response.status == 422) {
            this.openSnackbar(
              true,
              this.upperCaseTitleName(error.response.data.errors.due_date[0])
            );
          }
          if (error.response.status == 403) {
            this.openSnackbar(true, error.response.data.error_msg);
          }
        });
    },
    setTempMembers(payload) {
      this.tempMembers = payload;
    },

    deleteTimeEntry(item) {
      if (
        this.getActiveTimeEntry &&
        item.entry_id == this.getActiveTimeEntry.entry_id
      ) {
        this.openSnackbar(true, "Cannot delete active time entry");
        return;
      }

      this.$store
        .dispatch("deleteTimeEntry", {
          entry_id: item.entry_id,
          task: this.getTask(this.taskToEdit.task_id),
          loggedInUser: this.getLoggedInUser,
          duration: this.getTimeEntry(this.taskToEdit.task_id, item.entry_id)
            .duration,
        })
        .then(() => {
          this.openSnackbar(false, "Time entry deleted successfully");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Edit Start/End time for any entry
    editTimeEntry(interval) {
      let task = this.taskToEdit;
      let start_time = moment(
        `${this.entryDate} ${this.startTime}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      let end_time = moment(
        `${this.entryDate} ${this.endTime}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      let duration = moment.duration(end_time.diff(start_time)).asSeconds();
      this.$store
        .dispatch("editCardTimeEntry", {
          company_id: this.getSelectedCompany.id,
          entry_id: interval.entry_id,
          start_time: start_time.format("YYYY-MM-DD HH:mm:ss"),
          end_time: end_time.format("YYYY-MM-DD HH:mm:ss"),
          duration,
          project_id: task.project ? task.project.id : null,
          task_id: task.task_id,
        })
        .catch(() => {
          this.openSnackbar(
            true,
            "The end time must be a date after start time"
          );
          this.flag = false;
        });
      this.timeEntryMenu = false;
    },
  },
  beforeDestroy() {
    eventBus.$off("openSideBar");
  },
};
</script>

<style scoped>
.bg-hover {
  background-color: #e5efff !important;
}
.underline-hover:hover {
  text-decoration: underline;
}
.dropdown-width {
  width: 300px;
}
.close-btn {
  float: inline-end;
}
.delete-task-block {
  width: 286px;
  height: 40px;
  border: 1px solid #c60b2b;
}
.delete-task-text {
  color: #c60b2b;
}
.task-bar-btns-borders {
  border: 1px #2b6ad8 solid;
  color: #2b6ad8;
  border-radius: 20px;
  background-color: #e5efff !important;
}
.task-bar-btn-dimensions {
  height: 28px !important;
  width: 150px !important;
}
.status-chip-kanban {
  width: 80px;
  height: 28px;
}
.v-text-field--outlined >>> fieldset {
  border-color: #dcd8f3;
}
.expanding-chevron-bg {
  border: 1px solid #1cc283;
  background-color: rgba(28, 194, 131, 0.12);
}
.cross-icon-style {
  background-color: rgb(255, 234, 234) !important;
}
.interval-time:hover {
  text-decoration-line: underline;
}

.empty-avatar {
  height: 30px;
  width: 30px;
  background-color: #edebf9;
  border-radius: 60%;
  border: 1px dashed #757096;
  /* display: inline-block; */
}
</style>

<style>
#kanban-sidebar-due-date .v-date-picker-title {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  line-height: 1;
}
#kanban-sidebar-due-date .v-card__actions {
  align-items: center;
  display: contents !important;
  padding: 8px;
}
.v-application--is-ltr .v-date-picker-title .v-picker__title__btn {
  text-align: left;
  font-size: 18px !important;
}

.v-navigation-drawer__content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #5d5d5d;
  background-color: #5d5d5d;
}
.v-navigation-drawer__content::-webkit-scrollbar {
  width: 0px;
}
.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #424242;
  background-color: #424242;
}
</style>
